import React, {Component} from 'react';
import '../../../styles/Home.css'
import {Button} from "react-bootstrap";
import Dropzone from "react-dropzone";
import {Link} from "react-router-dom";
import BOKService from "./bokComponents/BOKService";
import Panel from "../Panel";
import {NotificationManager} from "react-notifications";
import Select from "react-select";

export default class MojeBilety extends Component {

    constructor(props) {
        super(props);

        let wybranyTemat = ''

        if (window.location.href.indexOf('zwrot') > -1) {
            wybranyTemat = {value: 'Zwrot biletu nr:', label: 'Zwrot biletu'}
        }

        let dodajZgloszenie = false;

        if (this.props.dodajZgloszenie !== null && this.props.dodajZgloszenie !== undefined) {
            dodajZgloszenie = this.props.dodajZgloszenie
        }

        this.state = {
            loading: true,
            data: [],
            tresc: '',
            loader: false,
            dodajZgloszenie: dodajZgloszenie,
            temat: '',
            tematy: [
                {value: 'Faktury / ceny', label: 'Faktury / ceny'},
                {value: 'Informacje', label: 'Informacje'},
                {value: 'Zwrot biletu nr:', label: 'Zwrot biletu'},
                {value: 'Inne', label: 'Inne'},
            ],
            wybranyTemat: wybranyTemat,
            nrRez: '',
            tematInvalid: false,
            nrRezInvalid: false,
            trescInvalid: false,
            plik: [],
            plikBase: '',
            plikInvalid: false
        };

        this.handleTresc = this.handleTresc.bind(this);
        this.handleTemat = this.handleTemat.bind(this);
        this.handleWybranyTemat = this.handleWybranyTemat.bind(this);
        this.handleNrRez = this.handleNrRez.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        BOKService.getZgloszenia(JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
            .then(function (response) {
                this.setState({data: response.data, loading: false})
            }.bind(this)).catch((e) => {
            console.log(e)
        })
    }

    handleTresc(e) {
        this.setState({tresc: e.target.value})
    }

    handleTemat(e) {
        this.setState({temat: e.target.value})
    }

    handleWybranyTemat(e) {
        let temat = e.value
        if (e.value === 'Inne') {
            temat = ''
        }
        this.setState({wybranyTemat: e, temat: temat})
    }

    handleNrRez(e) {
        if (e.target.value.length <= 18) {
            this.setState({nrRez: e.target.value})
        }
    }

    onDrop(accepted, rejected) {
        if (rejected.length !== 0) {
            this.setState({plikInvalid: true, plik: []})
        } else {
            this.getBase64(accepted);
            this.setState({plikInvalid: false, plik: accepted})
        }
    }

    getBase64(file) {
        let reader = new FileReader();
        reader.readAsDataURL(file[0]);
        reader.onload = () => {
            this.setState({plikBase: reader.result.substr(reader.result.indexOf(',') + 1)})
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    postZgloszenie() {
        let name = '';
        let type = '';
        let size = 0;
        let plik = null;
        let temat = this.state.wybranyTemat.value
        if (this.state.plik[0] !== null && this.state.plik[0] !== undefined) {
            plik = this.state.plikBase;
            name = this.state.plik[0].name;
            size = this.state.plik[0].size;
            type = this.state.plik[0].type
        }
        if (this.state.wybranyTemat.label === 'Zwrot biletu') {
            temat = this.state.wybranyTemat.value + ' ' + this.state.nrRez
        }
        if (this.state.wybranyTemat.label === 'Inne') {
            temat = 'Inne: ' + this.state.temat
        }
        BOKService.postZgloszenie(JSON.parse(sessionStorage.getItem('loggedIn')).login, JSON.parse(sessionStorage.getItem('loggedIn')).imie,
            JSON.parse(sessionStorage.getItem('loggedIn')).nazwisko, this.state.nrRez, plik, name, size, type,
            temat, this.state.tresc, JSON.parse(sessionStorage.getItem('loggedIn')).idKl)
            .then(function (response) {
                this.setState({
                    temat: '',
                    tresc: '',
                    nrRez: '',
                    plik: [],
                    plikBase: '',
                    plikInvalid: false,
                    tematInvalid: false,
                    nrRezInvalid: false,
                    trescInvalid: false,
                    dodajZgloszenie: false,
                    loader: false
                });
                this.componentDidMount()
                NotificationManager.success("", "Zgłoszenie zostało wysłane ", 5000)

            }.bind(this))
            .catch((e) => {
                console.log(e)
            })
    }

    wyslijZgloszenie() {
        this.setState({loader: true}, () => {
            let temat, tresc, nrRez;
            if (this.state.temat.length <= 0) {
                temat = true
            } else {
                if (this.state.wybranyTemat.label === 'Zwrot biletu') {
                    if (this.state.nrRez.length === 0 || isNaN(this.state.nrRez)) {
                        nrRez = true
                    }
                }
            }
            if (this.state.tresc.length <= 0) {
                tresc = true
            }
            if (!temat && !nrRez && !tresc) {
                this.setState({tematInvalid: temat, trescInvalid: tresc, nrRezInvalid: nrRez, loader: false})
                this.postZgloszenie()
            } else {
                this.setState({tematInvalid: temat, trescInvalid: tresc, nrRezInvalid: nrRez, loader: false})
            }
        })
    }

    render() {
        return <Panel>
            <div>

                <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Biuro Obsługi Klienta</b></h4>
                <br/>
                <div className="row">
                    <div className="col-sm-12 buttonBokMobilka">
                        {this.state.dodajZgloszenie ? <Link to={'/konto/bok'}><Button bsStyle={'success'}
                                                                                      onClick={() => this.setState({dodajZgloszenie: !this.state.dodajZgloszenie})}>Pokaż
                                zgłoszenia</Button></Link> :
                            <Link to={'/konto/bok/dodaj-zgloszenie'}><Button bsStyle={'success'}
                                                                             onClick={() => this.setState({dodajZgloszenie: !this.state.dodajZgloszenie})}>Dodaj
                                zgłoszenie</Button></Link>}
                    </div>
                </div>
                <hr/>
                {!this.state.dodajZgloszenie ?
                    <div>
                        {this.state.loading ? <div>
                            <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}>
                                <i
                                    className="fa fa-spinner fa-pulse fa-2x fa-fw"
                                    style={{
                                        color: '#58b13d'
                                    }}> </i></div>
                        </div> : <div>
                            {this.state.data.length !== 0 ? <div>
                                    {this.state.data.sort((a, b) => parseInt(b.idZgl) - parseInt(a.idZgl)).map((item, index) => {
                                        return <Link style={{textDecoration: 'none', color: 'inherit'}}
                                                     to={'/konto/bok/zgloszenie/' + item.idZgl}>
                                            <div
                                                className={item.czyOdpBok ? "wynik linkBokNew" : item.status === 0 || item.status === 2 ? "wynik linkBok" : "wynik linkBokClosed"}
                                                style={item.czyOdpBok ? {
                                                    border: '1px solid #17a2b8',
                                                    borderLeft: '5px solid #17a2b8'
                                                } : (item.status === 0 || item.status === 2 ? {borderLeft: '5px solid #8dc846'} : {borderLeft: '5px solid #989898'})}>
                                                <div className="row">
                                                    <div className="col-sm-9">
                                                        <div className="col-sm-12">
                                                            <small>Data: <b>{item.dataWpisu.substr(0, 10) + ' ' + item.dataWpisu.substr(11, 5)}</b>
                                                            </small>
                                                        </div>
                                                        <div className="col-sm-12">Temat: <b
                                                            style={{wordWrap: 'break-word'}}>{item.temat}</b></div>
                                                    </div>
                                                    <div className="col-sm-3 text-right">
                                                        {item.status === 0 ? <div>
                                                                <small><font color='#8dc846'>Wątek otwarty<i
                                                                    className="fa fa-check" aria-hidden="true"> </i></font>
                                                                </small>
                                                            </div> :
                                                            (item.status === 1 ? <div>
                                                                <small><font color='#989898'>Wątek zamknięty<i
                                                                    className="fa fa-times" aria-hidden="true"> </i></font>
                                                                </small>
                                                            </div> : <div>
                                                                <small><font color='#17a2b8'>Wątek w realizacji<i
                                                                    className="fa fa-gear" aria-hidden="true"> </i></font>
                                                                </small>
                                                            </div>)
                                                        }
                                                        {item.czyOdpBok ? <div>
                                                                <small><font color='#17a2b8'><b>Nowa wiadomość</b><i
                                                                    className="fa fa-check" aria-hidden="true"> </i></font>
                                                                </small>
                                                            </div> :
                                                            <div>
                                                                <small><font color='#989898'>Brak nowych wiadomości<i
                                                                    className="fa fa-times" aria-hidden="true"> </i></font>
                                                                </small>
                                                            </div>}
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    })}</div> :
                                <div className="text-center" style={{fontSize: '1.5rem', marginTop: 25}}>Brak
                                    zgłoszeń</div>}</div>}</div> :
                    <div>
                        <div>
                            <b>Temat: <font style={{color: 'red'}}>*</font></b>
                            <Select
                                onChange={this.handleWybranyTemat}
                                options={this.state.tematy}
                                value={this.state.wybranyTemat}
                                placeholder="Wybierz temat"
                                matchPos="start"
                                style={{height: 38, marginTop: 10, marginBottom: 10, borderColor: '#e0e0e0'}}
                                clearable={false}
                            />
                            {this.state.wybranyTemat.value === 'Inne' ?
                                <div>
                                    <b>Treść tematu: </b>
                                    <input type="text" value={this.state.temat} onChange={this.handleTemat}
                                           maxLength={40}
                                           style={{
                                               marginTop: 10,
                                               width: '100%',
                                               border: '1px solid #e0e0e0',
                                               borderRadius: 5,
                                               padding: 10,
                                               marginBottom: 10
                                           }}
                                           placeholder={"Wpisz temat..."}/>
                                </div> : null}
                            {this.state.wybranyTemat.label === 'Zwrot biletu' ?
                                <div>
                                    <b>Nr biletu: </b>
                                    <input type="number"
                                           onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === ',') && evt.preventDefault()}
                                           value={this.state.nrRez}
                                           onChange={this.handleNrRez}
                                           style={{
                                               marginTop: 10,
                                               width: '100%',
                                               border: '1px solid #e0e0e0',
                                               borderRadius: 5,
                                               padding: 10,
                                               marginBottom: 10
                                           }}
                                           placeholder={"Wpisz numer biletu..."}/>
                                    {this.state.nrRezInvalid ?
                                        <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy
                                            podać
                                            poprawny numer biletu.</div> : null}
                                </div> : null}
                            {this.state.tematInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy
                                    podać
                                    temat.</div> : null}
                        </div>
                        <div>
                            <b>Treść zgłoszenia: <font style={{color: 'red'}}>*</font></b>
                            <textarea rows={10} value={this.state.tresc} maxLength={1000} onChange={this.handleTresc}
                                      style={{
                                          marginTop: 10,
                                          width: '100%',
                                          border: '1px solid #e0e0e0',
                                          borderRadius: 5,
                                          padding: 10
                                      }}
                                      placeholder={"Wpisz wiadomość..."}/>
                            {this.state.trescInvalid ?
                                <div className="niepoprawneDaneOsobowe" style={{fontSize: '0.875rem'}}>Należy podać
                                    treść.</div> : null}
                        </div>
                        <div className="row" style={{marginTop: 5}}>
                            <div className="col-sm-12">
                                <b>Plik: </b>
                                <Dropzone maxSize={10000000}
                                          accept={'image/jpeg, image/png, application/pdf'}
                                          style={{
                                              maxWidth: '100%',
                                              height: 150,
                                              border: '1px dashed #ced4da',
                                              borderRadius: '0.25rem',
                                              paddingTop: 15,
                                              marginTop: 10,
                                              marginBottom: 10,
                                              textAlign: 'center',
                                              fontSize: '0.875rem',
                                              color: '#565756',
                                              cursor: 'pointer'
                                          }}
                                          onDrop={(accepted, rejected) => {
                                              this.onDrop(accepted, rejected)
                                          }}>
                                    {this.state.plik.length === 0 ? <div>
                                        <div style={{paddingTop: '5%'}}>Maksymalny rozmiar pliku: 10mb</div>
                                        <div style={{color: '#1e90ff'}}>Akceptowane typy plików: .png, .jpg, .jpeg,
                                            .pdf
                                        </div>
                                        {this.state.plikInvalid ?
                                            <div className="niepoprawneDaneOsobowe"
                                                 style={{fontSize: '0.875rem'}}>Format lub rozmiar pliku nie może zostać
                                                zaakceptowany.</div> : null}
                                    </div> : <div>
                                        <div style={{paddingTop: '4%'}}><b>{this.state.plik[0].name}</b></div>
                                        <p>(Kliknij by zmienić zdjęcie)</p>
                                    </div>}
                                </Dropzone>
                            </div>
                        </div>
                        <div className="text-right">
                            <Button bsStyle={'success'} disabled={this.state.loader} onClick={() => {
                                this.wyslijZgloszenie()
                            }}>Wyślij zgłoszenie</Button>
                            {this.state.loader ? <div className="loaderDim" style={{marginTop: 5}}><i
                                className="fa fa-spinner fa-pulse fa-fw"
                                style={{
                                    color: '#58b13d'
                                }}> </i></div> : null}
                        </div>
                    </div>
                }
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/BOK.js